import React, { lazy, Suspense } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import { componentLoader } from '@nw/shared/utils';

import { SeoTags } from '../../components/SeoTags';
import {
  NIAT_APPLICATION_PORTAL_HOME_ROUTE,
  NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH
} from '../../constants/RouteConstants';
import { applicationRouteSeoInfo } from '../../constants/SEOInfoConfigDetails/ApplicationPage';
import { natTopinLaunchRouteSeoInfo } from '../../constants/SEOInfoConfigDetails/NatTopinLaunchEntryPage';
import {
  withNiatApplicationPortalMachine,
  WithNiatApplicationPortalMachineProps
} from '../../hocs/withNiatApplicationPortalMachine';

const HomePage = lazy(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "NiatApplicationHomePage" */ '../../components/HomePage'
        )
    ) as Promise<{ default: React.ComponentType<any> }>
);

const NatTopinLaunchEntryPage = lazy(
  () =>
    componentLoader(
      () =>
        import(
          /* webpackChunkName: "NatTopinLaunchEntryPage" */ '../../components/NatTopinLaunchEntryPage'
        )
    ) as Promise<{ default: React.ComponentType<any> }>
);

/**
 * Single `useNiatApplicationMachine` for `/application` and NAT TOPIN launch entry (`/take-nat`), so navigating
 * between them does not tear down the machine or re-run bootstrap APIs.
 */
const HomeAndExamRoute = (
  props: WithNiatApplicationPortalMachineProps
): React.ReactElement => {
  const { pathname } = useLocation();

  return (
    <>
      {pathname === NIAT_APPLICATION_PORTAL_HOME_ROUTE ? (
        <SeoTags seoInfo={applicationRouteSeoInfo} />
      ) : null}
      {pathname === NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH ? (
        <SeoTags seoInfo={natTopinLaunchRouteSeoInfo} />
      ) : null}
      <Suspense fallback={null}>
        <Switch>
          <Route
            exact
            path={NIAT_NAT_TOPIN_LAUNCH_ROUTE_PATH}
            render={() => <NatTopinLaunchEntryPage {...props} />}
          />
          <Route
            exact
            path={NIAT_APPLICATION_PORTAL_HOME_ROUTE}
            render={() => <HomePage {...props} />}
          />
        </Switch>
      </Suspense>
    </>
  );
};

export default withNiatApplicationPortalMachine(HomeAndExamRoute);
